/**
 * Zodiac Signs with Emojis
 * Listed in chronological order by date range
 */

export const ZODIAC_SIGNS = [
  { id: 'aries', name: 'Aries', emoji: '\u2648', dates: 'Mar 21 - Apr 19' },
  { id: 'taurus', name: 'Taurus', emoji: '\u2649', dates: 'Apr 20 - May 20' },
  { id: 'gemini', name: 'Gemini', emoji: '\u264A', dates: 'May 21 - Jun 20' },
  { id: 'cancer', name: 'Cancer', emoji: '\u264B', dates: 'Jun 21 - Jul 22' },
  { id: 'leo', name: 'Leo', emoji: '\u264C', dates: 'Jul 23 - Aug 22' },
  { id: 'virgo', name: 'Virgo', emoji: '\u264D', dates: 'Aug 23 - Sep 22' },
  { id: 'libra', name: 'Libra', emoji: '\u264E', dates: 'Sep 23 - Oct 22' },
  { id: 'scorpio', name: 'Scorpio', emoji: '\u264F', dates: 'Oct 23 - Nov 21' },
  { id: 'sagittarius', name: 'Sagittarius', emoji: '\u2650', dates: 'Nov 22 - Dec 21' },
  { id: 'capricorn', name: 'Capricorn', emoji: '\u2651', dates: 'Dec 22 - Jan 19' },
  { id: 'aquarius', name: 'Aquarius', emoji: '\u2652', dates: 'Jan 20 - Feb 18' },
  { id: 'pisces', name: 'Pisces', emoji: '\u2653', dates: 'Feb 19 - Mar 20' },
];

export default ZODIAC_SIGNS;
